var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24998 3.75V6H3.99998C2.91532 6 2.03232 6.86344 2.00085 7.94048L7.26874 12.1989L11.25 12.2419V11C11.25 10.5858 11.5858 10.25 12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V12.2419L16.7312 12.1989L21.9991 7.94048C21.9677 6.86344 21.0847 6 20 6H16.75V3.75C16.75 2.7835 15.9665 2 15 2H8.99998C8.03348 2 7.24998 2.7835 7.24998 3.75ZM8.99998 3.5H15C15.1381 3.5 15.25 3.61193 15.25 3.75V6H8.74998V3.75C8.74998 3.61193 8.86191 3.5 8.99998 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.86858L17.4715 13.5293C17.3402 13.6354 17.1769 13.6941 17.0081 13.696L12.75 13.7419V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V13.7419L6.9919 13.696C6.82308 13.6941 6.65981 13.6354 6.52851 13.5293L2 9.86858V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9.86858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase4);
export default __webpack_public_path__ + "static/media/briefcase-4.1ee3b512361007a33bc8d7c1d952f164.svg";
export { ForwardRef as ReactComponent };